@if (siteRag) {
  <main [class.fullscreen]="isFullscreen">
    <div class="row">
      <header>
        <div></div>
        <div class="calendar" (click)="isSelectingDate = !isSelectingDate">
          <span
            >{{ header.month }} {{ header.year }}
            @if (header.toYear) {
              <span> - {{ header.toMonth }} {{ header.toYear }} </span>
            }
          </span>
          @if (isSelectingDate) {
            <div>
              <!-- @todo fix-->
              <app-calendar hideOnDateTimeSelect="true" (onSelect)="dateChanged()" [maxDate]="maxDate" [minDate]="minDate" inline="true" [(ngModel)]="selectingDate" view="month" dateFormat="mm/yy" [yearNavigator]="true" yearRange="2020:2022"></app-calendar>
            </div>
          }
        </div>
        <div>
          <span class="value" title="Number of months to show" (click)="monthsClick()">{{ defaults.months }}</span>
          <span class="mdi mdi-fullscreen" title="Toggle fullscreen" (click)="isFullscreen = !isFullscreen"></span>
          <span class="mdi" [class.mdi-table-of-contents]="defaults.layout === 'row'" [class.mdi-view-grid]="defaults.layout === 'grid'" title="Change layout" (click)="layoutClick()"></span>
        </div>
      </header>
    </div>
    <div class="row" [class.layout-row]="defaults.layout === 'row'">
      @for (assetId of siteRag.assetIds; track assetId; let i = $index) {
        <div [class.col-md-6]="defaults.layout === 'grid'" [class.col-md-12]="defaults.layout === 'row'" [class.pagebreakbefore]="i % 2">
          <div class="bounds">
            <app-asset-rag-report [presentation]="defaults.layout" [assetId]="assetId" [days]="siteRag.items[assetId]" [focusItem]="focusDay"></app-asset-rag-report>
          </div>
        </div>
      }
    </div>
  </main>
}
